// extracted by mini-css-extract-plugin
export var backHashtag = "boxAccordion-module--backHashtag--FkRfE";
export var backPanel = "boxAccordion-module--backPanel--tohI+";
export var button = "boxAccordion-module--button--Oks3y";
export var buttons = "boxAccordion-module--buttons--kyIjP";
export var hashtag = "boxAccordion-module--hashtag--ELf1W";
export var icon = "boxAccordion-module--icon--fzoI9";
export var overlap = "boxAccordion-module--overlap--vx5U8";
export var panel = "boxAccordion-module--panel--IlsWt";
export var panelNumber = "boxAccordion-module--panelNumber--wqS1s";
export var panelText = "boxAccordion-module--panelText--6D+So";
export var panelTextComing = "boxAccordion-module--panelTextComing--EVNBb";
export var panelTitle = "boxAccordion-module--panelTitle--Egedi";
export var posIcon = "boxAccordion-module--posIcon--f1Dfx";
export var text = "boxAccordion-module--text--C4uaI";
export var timing = "boxAccordion-module--timing--54Cbh";
export var title = "boxAccordion-module--title--U4uuJ";
export var titleAccordion = "boxAccordion-module--titleAccordion--kxpNl";
export var titleAccordionOpen = "boxAccordion-module--titleAccordionOpen--PkQlS";
export var titleOpen = "boxAccordion-module--titleOpen--qYkBV";
export var wrapper = "boxAccordion-module--wrapper--PpxPw";